'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

declare global {
  interface Window {
    dataLayer?: Object[]
  }
}

export const PhnxPushDataToGTM: React.FC = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (!searchParams) return

    const queryParams: Record<string, string> = {}
    searchParams.forEach((value: string, key: string) => {
      queryParams[key] = value
    })

    if (Object.keys(queryParams).length > 0) {
      // Push data to GTM
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'jotformConversion',
        ...queryParams,
      })

      //console.log('SUCCESS: Pushed to GTM:', queryParams)

      // Remove query params from URL without reloading the page
      window.history.replaceState({}, '', pathname)
    } else {
      console.error('No query params detected')
    }
  }, [searchParams, pathname])

  return null
}
